import { render, staticRenderFns } from "./SettingsAdminForm.vue?vue&type=template&id=6e07cbfd&scoped=true"
import script from "./SettingsAdminForm.vue?vue&type=script&lang=js"
export * from "./SettingsAdminForm.vue?vue&type=script&lang=js"
import style0 from "./SettingsAdminForm.vue?vue&type=style&index=0&id=6e07cbfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07cbfd",
  null
  
)

export default component.exports